import React, { useState, useEffect} from "react";
import { makeStyles, createMuiTheme, ThemeProvider} from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import axios from "axios";
import Autocomplete from "@material-ui/lab/Autocomplete";
import InputLabel from '@material-ui/core/InputLabel';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import MessageBox from "../../../components/MessageBox/MessageBox";
import { green } from '@material-ui/core/colors';

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "800px",
		margin: "0 auto",
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		border: "2px solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
		width: "800px",
		maxHeight:"100%",
		overflow: "auto",
	},
	root: {
		"& .MuiTextField-root": {
			width: "100%",
		},
	},
	button: {
		textAlign: "right",
		marginTop: "30px",
		"& .MuiButton-containedPrimary": {
			marginRight: "10px",
		},
	},

	buttonMarginRight: {
		marginRight: "0.5rem",
	},
}));

export default function AddContentNav(props) {
	const {showModal} = props;
	const classes = useStyles();
	const [open, setOpen] = useState(false);
	const [mainNav, setMainNav] = useState([]);
	const [cn_fkey, setCnFkey] = useState([]);
	const [hasline, setHasline] = useState('');
	const [description, setDescription] = useState('');
	const [name, setName] = useState('');

	const [url, setUrl] = useState('');
	const [mainNavUrl, setMainNavUrl] = useState('');

	const [btnDisabled, setBtnDisabled] = useState(true);

	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	//Message Box EOF

	const clearFields = () => {
		setHasline('');
		setDescription('');
		setName('');
		setUrl('');
	};

	const handleOpen = () => {
		setOpen(true);
		clearFields();
	};

	const handleClose = () => {
		setOpen(false);
	};

	const getMainNav = async() => {
		await axios.get(process.env.REACT_APP_API_URL+'get_main_nav_table', {
			}).then(function (res) {
				setMainNav(res.data.data);
		  	}).catch(function (error) {	
				// console.log(error);
	  		});
	}

	const selectMainNavProps = {
		options: mainNav,
		getOptionLabel: (option) => option.main_nav_desc,
	};

	useEffect(() => { //
		getMainNav();
	}, []);

	useEffect(() => {
		if (mainNavUrl && url && name && description && hasline) {
			setBtnDisabled(false); // re-enable
		} else {
			setBtnDisabled(true); // re-enable
		}
	}, [mainNavUrl,url,name,description,hasline]);

	const saveContentNav = async (position_name, main_nav, content_nav) => {
			const formData = new FormData();
			formData.append("cn_url", url);
			formData.append("cn_name", name);
			formData.append("cn_description", description);
			formData.append("cn_fkey", cn_fkey); 
			formData.append("cn_hasline", parseFloat(hasline)); 
	
			await axios.post(process.env.REACT_APP_API_URL+'add_content_nav', formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
					}
				}).then(function(res) {
					showModal('Added New Content Navigation '+ name, 'success');
					handleClose();
				  }).catch(function (error) {
					showModal('Something went wrong '+ error.message, 'warning');
					handleClose();
				  });
	}

	const handleSubmit = (e) => {
		e.preventDefault();
		saveContentNav();
    }


	return (
		<div>
				<Button variant="contained" color="primary" onClick={handleOpen} style ={{marginTop: "22px", marginLeft:"10px", backgroundColor: "#4caf50", color:"#fff"}}>
					Add Content Nav
				</Button>
			<Modal
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				className={classes.modal}
				open={open}
				onClose={handleClose}
				closeAfterTransition
				BackdropComponent={Backdrop}
				BackdropProps={{
					timeout: 500,
				}}
			>
				<Fade in={open}>
					<div className={classes.paper}>
						<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
						<h2 id="transition-modal-title">Add New Content Navigation</h2>
						<form onSubmit={handleSubmit} className={classes.root}>
							<Grid container spacing={2}>
								<Grid item xs={12} xl={12}> 
									<TextField id="outlined-basic" label="URL" variant="outlined"  style={{marginTop:"21px"}} placeholder="URL" fullWidth={true} inputProps={{ 'aria-label': 'URL' }} value={url} onChange={e => setUrl(e.target.value)}/>
								</Grid>	
								<Grid item xs={12} xl={12}> 
									<TextField id="outlined-basic" label="Name" variant="outlined"  placeholder="Name" fullWidth={true} inputProps={{ 'aria-label': 'Name' }} value={name} onChange={e => setName(e.target.value)}/>
								</Grid>	
								<Grid item xs={12} xl={12}> 
									<TextField id="outlined-basic" label="Description" variant="outlined"  placeholder="Description" fullWidth={true} inputProps={{ 'aria-label': 'Description' }} value={description} onChange={e => setDescription(e.target.value)}/>
								</Grid>	
								<Grid item xs={12} xl={12}> 
									<TextField id="outlined-basic" label="Hasline" type="number" variant="outlined"  placeholder="-1 or 1" fullWidth={true} inputProps={{ 'aria-label': 'Hasline' }} value={hasline} onChange={e => setHasline(e.target.value)}/>
								</Grid>	
								<Grid item xs={12} md={12} lg={12} xl={12}>
									<Autocomplete
												{...selectMainNavProps}
												id="auto-complete"
												autoComplete
												includeInputInList
												className={classes.autoComplete}
												renderInput={(params) => (
													<TextField
														{...params}
														label="Select Main Nav"
														margin="normal"
														variant="outlined"
													/>
												)}
												onChange={(event, newValue) => {
													if (!newValue == "" || !newValue == null){
														// console.log(newValue);
														setCnFkey(newValue.main_nav_id);
														setMainNavUrl(newValue.main_nav_href);
													}else{
														setCnFkey(null);
														setMainNavUrl('');
													}
												}}
									/>
								</Grid>	
								{/* <Grid item xs={12} xl={12}> 
									<TextField id="outlined-basic" label="Final Url Preview" variant="outlined"  placeholder="Final Url Preview" fullWidth={true} inputProps={{ 'aria-label': 'Final Url Preview', readOnly: true }} value={mainNavUrl+url}/>
								</Grid>	 */}
							</Grid>
							<div className={classes.button}>
								<Button
									variant="contained"
									onClick={handleClose}
									className={classes.buttonMarginRight}
								>
									Close
								</Button>
								<Button type="submit" disabled={btnDisabled} variant="contained" color="primary">
									Add Content Navigation
								</Button>
							</div>
						</form>
					</div>
				</Fade>
			</Modal>
		</div>
	);
}
